import { useTranslation } from '@sm360/hooks'
import { Tabs } from '@sm360/ui-library'
import clsx from 'clsx'
import React from 'react'

import { getQuoteDeskingPaymentOptions } from '../../apis/showroom/showroom.service'
import { Context } from '../../configs/state.manager'
import { payloadPaymentOptionsTransform } from '../../transforms/payloadPaymentOptions.transform'
import CashCard from '../cash/cash-card/CashCard'
import CashInvoice from '../cash/cash-invoice/CashInvoice'
import Container from '../common/container/Container'
import FinanceCard from '../finance/finance-card/FinanceCard'
import FinanceInvoice from '../finance/finance-invoice/FinanceInvoice'
import FinanceTerms from '../finance/finance-terms/FinanceTerms'
import LeaseCard from '../lease/lease-card/LeaseCard'
import LeaseInvoice from '../lease/lease-invoice/LeaseInvoice'
import LeaseTerms from '../lease/lease-terms/LeaseTerms'

const TabsCalculator = () => {
    const {
        state,
        state: {
            paymentOptions: { purchaseMethod, financeOptions },
        },
        dispatch,
    } = React.useContext(Context)

    const { t } = useTranslation()

    if (!financeOptions || !financeOptions.length) return null

    const financeInfos = financeOptions.find(({ purchaseMethod }) => purchaseMethod === 'finance')
    const leaseInfos = financeOptions.find(({ purchaseMethod }) => purchaseMethod === 'lease')

    let tabActive = 0 // cash
    if (purchaseMethod === 'finance' && financeInfos.isSelected) tabActive = 1 // Finance
    if (purchaseMethod === 'lease' && leaseInfos.isSelected) tabActive = 2 // Lease

    const tabsClassNames = {
        className: 'uk-tabs pc-tabsCalculator',
        selectedTabClassName: 'uk-tabs__tab--selected pc-tabsCalculator__tab--selected',
        selectedTabPanelClassName: 'uk-tabs__tab-panel--selected pc-tabsCalculator__tabPanel--selected',
    }

    const tabListCashClassNames = clsx('pc-tabsCalculator__tab')
    const tabListFinanceClassNames = clsx(
        'pc-tabsCalculator__tab',
        !financeInfos.isAvailable && 'pc-tabsCalculator__tab--disabled'
    )
    const tabListLeaseClassNames = clsx('pc-tabsCalculator__tab', !leaseInfos.isAvailable && 'pc-tabsCalculator__tab--disabled')

    const handleTabClick = async (tabIndex) => {
        try {
            let purchaseMethod = 'cash'
            if (tabIndex === 1) purchaseMethod = 'finance'
            if (tabIndex === 2) purchaseMethod = 'lease'

            const payload = payloadPaymentOptionsTransform({ state, purchaseMethod })
            const initPaymentOptions = await getQuoteDeskingPaymentOptions(payload)

            dispatch({ type: 'setPaymentOptions', paymentOptions: initPaymentOptions.data })
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div className='pc-calculator'>
            <Tabs activeIndex={tabActive} onTabClick={handleTabClick} {...tabsClassNames}>
                <div trigger={t('pc.cash')} className={tabListCashClassNames}>
                    <Container hasTwoCol>
                        <CashCard />
                        <CashInvoice />
                    </Container>
                </div>
                <div trigger={t('pc.finance')} className={tabListFinanceClassNames} disabled={!financeInfos.isAvailable}>
                    <Container hasTwoCol>
                        <FinanceCard />
                        <FinanceTerms />
                    </Container>
                    <Container>
                        <FinanceInvoice />
                    </Container>
                </div>
                <div trigger={t('pc.lease')} className={tabListLeaseClassNames} disabled={!leaseInfos.isAvailable}>
                    <Container hasTwoCol>
                        <LeaseCard />
                        <LeaseTerms />
                    </Container>
                    <Container>
                        <LeaseInvoice />
                    </Container>
                </div>
            </Tabs>
        </div>
    )
}

export default TabsCalculator
